import apiClient from './apiClient';

export interface ScreeningSessionResponse {
  token: string;
  candidate?: Record<string, any>;
  interviewDetails: any;
  status: string;
  callbackUrl?: string;
  webhookToken?: string;
}

export interface ScreeningFetchResult {
  success: boolean;
  session: ScreeningSessionResponse;
}

export interface ScreeningFeedbackPayload {
  feedback: any;
}

class ScreeningService {
  async fetchSession(token: string): Promise<ScreeningSessionResponse> {
    const response = await apiClient.get<ScreeningFetchResult>(`/screening/${token}`, undefined, false);
    return response.session;
  }

  async submitFeedback(token: string, payload: ScreeningFeedbackPayload): Promise<void> {
    await apiClient.post(`/screening/${token}/feedback`, payload, undefined, false);
  }

  async fetchResult(token: string): Promise<{ status: string; feedback: any }> {
    const response = await apiClient.get<{ success: boolean; status: string; feedback: any }>(`/screening/${token}/result`, undefined, false);
    return { status: response.status, feedback: response.feedback };
  }
}

const screeningService = new ScreeningService();
export default screeningService;
